export const useStyles = (theme) => ({
  menuItemContent: {
    display: "flex",
    alignItems: "center",
  },
});
